module.exports = __webpack_public_path__ + "img/b18-4.eb1080f8.jpg";